import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent, SwalPortalDirective } from "@sweetalert2/ngx-sweetalert2";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ConfigFacturaMasiva } from "./config-facturador-masivo";
import { Papa, ParseResult } from "ngx-papaparse";
import { FacturadorMasivoService } from "src/app/services/facturador-masivo.service";
import * as FileSaver from "file-saver";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { ArchivoExcelImportacion } from "src/app/models/ArchivoExcelImportacion";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TipoDte } from "src/app/models/tipoDte";
import { SolicitudFacturacionMasiva } from "src/app/models/SolicitudFacturacionMasiva";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { TipoArchivoImportacion } from "src/app/helpers/TipoArchivoImportacion.enum";
import { Router } from "@angular/router";
import { UtilitiesService } from "src/app/services/utilities.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { ImportacionMasiva } from "src/app/models/MassInvoicing/ImportacionMasiva";
//import * as moment from "moment";
import * as _moment from "moment";
import { Moment } from "moment";
import { DateTimeAdapter, OwlDateTimeComponent, OwlDateTimeFormats, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from "ng-pick-datetime";
import { MomentDateTimeAdapter } from "ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class";
import { Page } from "src/app/shared/models/Page";
import { ImportacionFilter } from "src/app/models/MassInvoicing/ImportacionFilter";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { DatePipe } from "@angular/common";
import { PermissionService } from "src/app/services/permission.service";
import { Observable } from "rxjs";
import { Response } from "src/app/shared/models/Response";
import { SortType } from "@swimlane/ngx-datatable";
import { resourceLimits } from "worker_threads";
import { EmisorService } from "src/app/services/emisor.service";
import { environment } from "src/environments/environment";
import { VerificacionCertificadoService } from "src/app/services/verificacion-certificado.service";
import { FoliosService } from "src/app/services/folios.service";
import { ExpresionDinero } from "src/app/models/Dte/ExpresionDinero.enum";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_MOMENT_DATE_TIME_FORMATS: OwlDateTimeFormats = {
	parseInput: "MM/YYYY",
	fullPickerInput: "l LT",
	datePickerInput: "MM/YYYY",
	timePickerInput: "LT",
	monthYearLabel: "MMM YYYY",
	dateA11yLabel: "LL",
	monthYearA11yLabel: "MMMM YYYY",
};

@Component({
	selector: "app-facturador-masivo",
	templateUrl: "./facturador-masivo.component.html",
	styleUrls: ["./facturador-masivo.component.scss"],
	providers: [
		NgbActiveModal,
		{
			provide: DateTimeAdapter,
			useClass: MomentDateTimeAdapter,
			deps: [OWL_DATE_TIME_LOCALE],
		},
		{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
		{ provide: OWL_DATE_TIME_LOCALE, useValue: "es" },
	],
})
export class FacturadorMasivoComponent implements OnInit, OnDestroy {
	SortType = SortType;
	private readonly compraOrigenImportacionId = 3;
	private readonly umbralRutsConsultaLenta = 30;
	private readonly umbralSegundosProcesoLento = 8 * 60;
	public esBoletaConDescuento = false;
	public netItemsConIva = 0;
	public configLocal = ConfigFacturaMasiva;
	public loading: boolean = false;
	public procesandoFacturacion: boolean = false;
	public procesoTardaMasEsperado: boolean = false;
	public tiempoProcesamiento: string = "00:00";
	public cantidadDocumentosProcesando: number = 0;
	public cantidadRutsPorConsultar: number = 0;
	private inicioProcesamiento: number = 0;
	private intervaloProcesamiento: any;
	rowsMantenedor: ImportacionMasiva[] = [];
	public searchRows: any[] = [];
	public searchCriteria;
	private saveRows: boolean = false;
	public dteFileForm: FormGroup;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public files: File[] = [];
	public tipoClienteSource;
	public empresasSource: Emisor[];
	public tipoDteSource;
	private addModal: NgbModalRef;
	private detailModal: NgbModalRef;
	private invoiceRequestModal: NgbModalRef;
	public validFile: boolean = false;
	public externalValidFile: boolean = false;
	public resultStringData: string = "";
	public fileData: Object[];
	public resultedFileDataDocuments: any[];
	public numberOfDocumentosToSend: number;
	public sumOfDocumentDetails: number;
	public sumaResumenDocumento: [number, number];
	public ivaTotal: number;
	public totalFinal: number;
	public totalRetencionesCompra: number = 0;
	public descuentoGlobal: number = 0;
	public recargoGlobal: number = 0;
	public descuentoGlobalBruto: number = 0;
	public recargoGlobalBruto: number = 0;
	public descuentoGlobalTipo: ExpresionDinero = null;
	public recargoGlobalTipo: ExpresionDinero = null;
	public ExpresionDinero = ExpresionDinero;
	public tipoClienteId: number = 0; // 0 Standard, 1 Exportacion, 2 Compras
	public resultData: any[];
	public emisorId: string;
	public currentEmisor: Emisor;
	public currentUser = this.tokenStorage.getUser() as SessionUser;
	public DetailString = "";
	public invalidColumns: Array<string> = [];
	public inconsistencies: any[] = [];
	public inconsistencyCount: number = 0;
	public invoiceRequestDate: any;
	public dateFrom: any = moment();
	public dateTo: any = moment();
	public dateToday: any = moment();
	public page: Page = new Page();
	public filter: ImportacionFilter = new ImportacionFilter();
	public selectedImportacion: ImportacionMasiva;
	public validationMessage: string = "";
	private paymentMatrixModalInstance: any;
	public dateMatrixRequest: any = moment();
	public todayString = moment();
	public componentStarted: boolean = false;
	public wrongDelimiter: boolean = false;
	public sucursalId: string = this.tokenStorage.getSubsidiary();
	private listFolioResumen: any[] = [];

	public get consultaMasivaRutsLenta(): boolean {
		return this.cantidadRutsPorConsultar > this.umbralRutsConsultaLenta;
	}

	public codigoSii: number;
	@ViewChild("tableMobile") tableRef: any;
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	//validation elements
	//Keys
	private validationKeysOriginalStandard = [
		"Id",
		"TipoDte",
		"FmaPago",
		"FechaEmision",
		"Vencimiento",
		"RutRecep",
		"GiroRecep",
		"Contacto",
		"CorreoRecep",
		"DirRecep",
		"CmnaRecep",
		"CiudadRecep",
		"RazonSocialRecep",
		"DirDest",
		"CmnaDest",
		"CiudadDest",
		"ReferenciaTpoDocRef",
		"ReferenciaFolioRef",
		"ReferenciaFchRef",
		"ReferenciaRazonRef",
		"ReferenciaCodigo",
		"CodigoProducto",
		"NombreProducto",
		"DescripcionProducto",
		"CantidadProducto",
		"PrecioProducto",
		"UnidadMedidaProducto",
		"DescuentoProducto",
		"RecargoProducto",
		"IndicadorExento",
		"TotalProducto",
		"GlosaDR",
		"TpoMov",
		"TpoValor",
		"ValorDR",
		"ValorOtrMnda",
		"IndExeDR",
	];
	private consumoAprOptionalKeys = [
		"FechaLectura",
		"LecturaAnterior",
		"LecturaActual",
		"ConsumoM3",
		"PeriodoCobrado",
		"FechaProxLectura",
		"Ruta",
		"NumMedidor",
		"NumCliente",
		"SaldoAnterior",
		"Tramo",
		"Desde",
		"Hasta",
		"M3Aplicado",
		"Valor",
		"SubTotal",
		"Referencia",
		"TituloPiePagina",
		"MensajePiePagina",
	];
	private validationKeyExport = [
		"Id",
		"TipoDte",
		"FmaPago",
		"FechaEmision",
		"Vencimiento",
		"CodigoInternoCliente",
		"RazonSocialCliente",
		"NombreFantasiaCliente",
		"GiroCliente",
		"EmailCliente",
		"DireccionCalleCliente",
		"DireccionNumeroCliente",
		"DireccionAdicionalCliente",
		"CiudadCliente",
		"EstadoCliente",
		"CodigoPaisCliente",
		"ReferenciaTpoDocRef",
		"ReferenciaFolioRef",
		"ReferenciaFchRef",
		"ReferenciaRazonRef",
		"CodigoProducto",
		"NombreProducto",
		"DescripcionProducto",
		"CantidadProducto",
		"PrecioProducto",
		"UnidadMedidaProducto",
		"DescuentoProducto",
		"RecargoProducto",
		"IndicadorExento",
		"TotalProducto",
		"ViaTransporte",
		"PuertoEmbarque",
		"PuertoDesembarque",
		"PaisDestino",
		"CodigoUnidadMedidaTara",
		"Tara",
		"CodigoUnidadMedidaPesoNeto",
		"PesoNeto",
		"CodigoUnidadMedidaPesoBruto",
		"PesoBruto",
		"CodigoBulto",
		"CantidadBulto",
		"Marcas",
		"IdContainer",
		"Sello",
		"EmisorSello",
		"TipoCambio",
		"TipoMoneda",
		"Flete",
		"Seguro",
		"CodigoModalidadVenta",
		"CodigoClausulaVenta",
		"TotalClausulaVenta"
	];
	private validationKeyPurchase = [
		"Id",
		"FmaPago",
		"FechaEmision",
		"Vencimiento",
		"RutProv",
		"RazonSocialProv",
		"GiroProv",
		"ContactoProv",
		"CorreoProv",
		"DirProv",
		"CmnaProv",
		"CiudadProv",
		"CodigoProducto",
		"NombreProducto",
		"DescripcionProducto",
		"CantidadProducto",
		"PrecioProducto",
		"UnidadMedidaProducto",
		"DescuentoProducto",
		"RecargoProducto",
		"IndicadorExento",
		"TotalProducto",
	];

	private validationSumKeyName = ["TotalProducto", "TotalProducto", "TotalProducto"];
	private validationKeysArray: Array<any> = [this.validationKeysOriginalStandard, this.validationKeyExport, this.validationKeyPurchase];
	@ViewChild("summaryModal") private summaryModal: TemplateRef<any>;
	@ViewChild("confirmSwal") private confirmSwal: SwalComponent;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;

	private innerSummaryRef: NgbModalRef;
	private currentSucursal = this.tokenStorage.getSubsidiary();
	public validDate: boolean = true;
	public superAdm = false;
	constructor(
		private formBuilder: FormBuilder,
		private validadorCertificadoService: VerificacionCertificadoService,
		private modalService: NgbModal,
		private facturadorService: FacturadorMasivoService,
		private papaParser: Papa,
		private tokenStorage: TokenStorageService,
		private localStorage: LocalStorageService,
		private router: Router,
		private ref: ChangeDetectorRef,
		public utilities: UtilitiesService,
		public activeModal: NgbActiveModal,
		public permissions: PermissionService,
		private emisorService: EmisorService,
		private foliosService: FoliosService,
		private sessionUserService: SessionUserService,
		private planUsuarioService: PlanUsuarioService
	) {
		this.superAdm = this.tokenStorage.getUser().superAdmin;
		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		if (this.superAdm) {
			this.getEmisoresFullList();
		}
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.tipoClienteSource = [
			{ id: "0", nombre: "Standard" },
			...(this.permissions.getPermission("40-19-10").asignado ? [{ id: "1", nombre: "Exportación" }] : []),
			{ id: "2", nombre: "Compras" },
		];
		this.emisorId = this.tokenStorage.getCompany();
		this.currentEmisor = this.empresasSource.find((empresa) => empresa.emisorId == this.emisorId);
		//this.searchElements(this.emisorId);
		this.filter.emisorId = this.emisorId;
		this.filter.sucursalId = this.currentSucursal;
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		this.createForm();
		this.saveRows = false;
		this.validarCertificado();

		const planActual = this.planUsuarioService.getActualPlan();
		if (planActual?.idPlanUsuario) {
			this.planUsuarioService.getCurrentDocuments(planActual.idPlanUsuario).subscribe({
				next: (result) => {
					if (result?.maxdtes === 0) {
						Swal.fire({
							icon: "warning",
							title: "Acceso no permitido",
							text: "Su plan actual (Sólo DTE Recibidos) no permite la emisión de documentos tributarios electrónicos. Será redirigido al mantenedor de documentos recibidos.",
							confirmButtonText: "Aceptar",
						}).then(() => {
							this.router.navigateByUrl("compras/documentos-recibidos");
						});
					}
				}
			});
		}
		
	}

	private async validarCertificado() {
		const validacionCertificado = await this.validadorCertificadoService.validar();
		if (validacionCertificado) {
			this.setPage({ offset: 0 });
		}
	}

	openAddDteFileModal(addNewModal) {
		this.files = [];
		this.addModal = this.modalService.open(addNewModal, {
			windowClass: "custom-modal",
			size: "xl",
		});
	}

	changeSearchedRows(data) {
		if (data != null) {
			this.rowsMantenedor = data;
		}
	}

	f() {
		return this.dteFileForm.controls;
	}

	ngAfterViewChecked() {
		if (!this.saveRows && (this.rowsMantenedor[0] != undefined || this.rowsMantenedor[0] != null)) {
			this.searchRows = this.rowsMantenedor;
			this.saveRows = true;
		}
	}

	downloadFile(id: string) {
		this.loading = true;
		this.facturadorService
			.getFile(id)
			.subscribe(
				(res) => {
					let uint8Array = res.data as Uint8Array;
					let b64Response = res.data;
					//obtained  8bit array from response that need to be transformed into a Blob
					try {
						const blobCsv = this.utilities.convertB64ToBlob(b64Response, "text/csv");
						FileSaver.saveAs(blobCsv, "lista_de_facturas.csv");
					} catch (error) {
						this.setSwalAndFire(this.currentSwal, "error", "Error en Archivo", "No fue posible obtener el archivo CSV, favor contactar al administrador\n" + error);
					}
				},
				(error) => {
					this.setSwalAndFire(this.currentSwal, "error", "Error", "Error al obtener el archivo. Intente más tarde." + this.utilities.setErrorMessageFromArray(error.error));
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	detail(detailModal, row: ImportacionMasiva) {
		this.loading = true;
		this.selectedImportacion = row;
		this.facturadorService.getDetail(row.importacionMasivaId).subscribe(
			(result) => {
				let resultString = result.data;
				if (resultString) {
					resultString.replace("\n", "<br>");
					this.DetailString = resultString;
					this.resultStringData = resultString;
					this.detailModal = this.modalService.open(detailModal, {
						windowClass: "",
						size: "lg",
						centered: true,
					});
				}
			},
			(error) => {
				this.setSwalAndFire(this.currentSwal, "error", "Error", "No es posible mostrar los detalles del Archivo en este momento, favor contactar al administrador.\n " + this.utilities.setErrorMessageFromArray(error.error));
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	relatedDtes(row: ImportacionMasiva) {
		let id = row.importacionMasivaId;
		let datePipe = new DatePipe("es-ES");
		let fechaCarga = datePipe.transform(row.fechaCarga, "dd-MM-yyyy");
		let horaCarga = datePipe.transform(row.fechaCarga, "HH:mm");
		let filterDescription = row.origen + " con fecha " + fechaCarga + " a las " + horaCarga;
		if (row.origenImportacionId == 1) {
			this.router.navigateByUrl("ventas/exportaciones", {
				state: {
					paramId: id,
					filterDescription: "Filtrado por " + filterDescription,
					filterEmisor: this.filter.emisorId,
					filterSucursal: this.filter.sucursalId,
					fechaDesde: row.fechaDesde,
					fechaHasta: row.fechaHasta,
				},
			});
		} else if (row.origenImportacionId == this.compraOrigenImportacionId) {
			this.router.navigateByUrl("compras/facturas-compras", {
				state: {
					paramId: id,
					filterDescription: "Filtrado por " + filterDescription,
					filterEmisor: this.filter.emisorId,
					filterSucursal: this.filter.sucursalId,
				},
			});
		} else {
			this.router.navigateByUrl("ventas/documentos-emitidos", {
				state: {
					paramId: id,
					filterDescription: "Filtrado por " + filterDescription,
					filterEmisor: this.filter.emisorId,
					fechaDesde: row.fechaDesde,
					fechaHasta: row.fechaHasta,
				},
			});
		}
	}

	onSubmit() {
		if (!this.canUploadSelectedType(false)) { return; }
		this.wrongDelimiter = false;

		if (this.dteFileForm.invalid) {
			Swal.fire({
				icon: "error",
				title: "Formulario inválido",
				text: "Por favor, completa todos los campos obligatorios.",
			});
			return;
		}

		this.loading = true;
		this.papaParser.parse(this.files[0], {
			header: true,
			delimiter: ";",
			complete: (result) => {
				this.wrongDelimiter = result.meta.delimiter == "," && this.checkConflictInDelimiter(result);
				this.checkConflictInDelimiter(result);
				let withComments = result.data.some((obj) => Object.keys(obj).some((prop) => prop.indexOf("#") !== -1));

				let cleanData: any[] = [];
				if (withComments) {
					// LIMPIAR comentarios y filas vacías
					let dataCommentRemoved = result.data.filter((obj) => !Object.values(obj).some((val) => (val as string).includes("#")));
					for (let index = 1; index < dataCommentRemoved.length; index++) {
						this.concatValuesToObjProperty(dataCommentRemoved[index], "#A. Disposiciones Generales:", "__parsed_extra");
					}
					let preCleanData = this.CsvDataToObjects(dataCommentRemoved);
					cleanData = preCleanData.filter((obj) => obj["Id"] != "");
				} else {
					cleanData = result.data.filter((obj) => obj["Id"] != "");
				}

				// VALIDACIÓN DE COLUMNAS SEGÚN tipoCliente
				let tipoClienteObject = this.dteFileForm.controls.tipoCliente.value;
				let validationKeys = this.validationKeysArray[tipoClienteObject.id];
				const currentHeaders = Object.keys(cleanData[0] || {});

				// valida columnas obligatorias base
				const missingKeys = validationKeys.filter((k) => !currentHeaders.includes(k));

				// valida bloque opcional APR solo para tipo standard
				let aprValidation = { valid: true, missing: [] as string[] };
				if (+tipoClienteObject.id === 0) {
					aprValidation = this.validateOptionalAprColumns(currentHeaders);
				}

				this.validFile = missingKeys.length === 0 && aprValidation.valid;

				if (missingKeys.length > 0) {
					Swal.fire({
						icon: "error",
						title: "Columnas faltantes",
						html: `
						El CSV no contiene las siguientes columnas obligatorias:<br>
						<b>${missingKeys.join("</b>, <b>")}</b>`,
					});
					this.loading = false;
					this.ref.detectChanges();
					return;
				}

				if (!aprValidation.valid) {
					Swal.fire({
						icon: "error",
						title: "Columnas APR incompletas",
						html: `
						El CSV contiene algunas columnas de consumo APR, pero faltan las siguientes:<br>
						<b>${aprValidation.missing.join("</b>, <b>")}</b><br><br>
						Debes enviar todas las columnas APR o no enviar ninguna.
					`,
					});
					this.loading = false;
					this.ref.detectChanges();
					return;
				}
				const allowedKeys =
					+tipoClienteObject.id === 0
						? [...validationKeys, ...this.consumoAprOptionalKeys]
						: [...validationKeys];

				if (!this.validFile) {
					this.invalidColumns = currentHeaders.filter((propertyName) => !allowedKeys.includes(propertyName));
				} else {
					this.invalidColumns = [];
				}
				this.fileData = cleanData;
				this.cantidadRutsPorConsultar = +tipoClienteObject.id === TipoArchivoImportacion.Standard
					? this.contarRutsReceptorPorConsultar(cleanData)
					: 0;
				let documentsByDetail = this.sortByProperty(this.fileData, "Id");
				this.resultedFileDataDocuments = documentsByDetail;
				this.numberOfDocumentosToSend = Object.keys(this.resultedFileDataDocuments).length;

				let sumResult = this.sumArrayProperty(this.fileData, this.validationSumKeyName[tipoClienteObject.id]);
				let sumaResumen: [number, number] = this.getSumAfectosExentos(this.fileData, this.validationSumKeyName[tipoClienteObject.id], "IndicadorExento");

				if (sumaResumen && sumaResumen[0] != null && sumaResumen[1] != null) {
					this.ivaTotal = Math.round(sumaResumen[0] * environment.taxPercentage);
					this.totalFinal = sumaResumen[0] + sumaResumen[1] + this.ivaTotal;
				}
				this.sumaResumenDocumento = sumaResumen;
				this.tipoClienteId = +tipoClienteObject.id;
				this.sumOfDocumentDetails = sumResult;

				// En Factura de Compra, el resumen previo no debe aplicar DR global desde CSV.
				// El monto esperado se calcula con neto/iva y retenciones por item.
				const { totalDescuentoPesos, totalDescuentoPorcentaje, totalRecargopesos, totalRecargoporcentaje } = this.esCompra()
					? { totalDescuentoPesos: 0, totalDescuentoPorcentaje: 0, totalRecargopesos: 0, totalRecargoporcentaje: 0 }
					: this.calculateGlobalDiscountAndRecargo(cleanData);

				const totalDescuento = totalDescuentoPesos + totalDescuentoPorcentaje;
				const totalRecargo = totalRecargopesos + totalRecargoporcentaje;

				this.descuentoGlobalBruto = totalDescuentoPesos;
				this.recargoGlobalBruto = totalRecargopesos;
				this.descuentoGlobalTipo = ExpresionDinero.$;
				this.recargoGlobalTipo = ExpresionDinero.$;
				this.descuentoGlobal = totalDescuento;
				this.recargoGlobal = totalRecargo;
				this.totalRetencionesCompra = this.esCompra() ? this.getTotalRetencionesCompra(cleanData) : 0;

				const base = this.sumaResumenDocumento[1] > 0 ? this.sumaResumenDocumento[1] : this.sumaResumenDocumento[0];
				const netoAjustado = base - totalDescuento + totalRecargo;
				const primerRow = cleanData[0] as any;
				const tipoDteCsv = this.esCompra() ? "46" : primerRow["TipoDte"];

				this.esBoletaConDescuento = (tipoDteCsv === "39" || tipoDteCsv === "41") && (totalDescuento > 0 || totalRecargo > 0);
				if (this.esBoletaConDescuento) {
					this.netItemsConIva = Math.round(this.sumOfDocumentDetails * (1 + environment.taxPercentage));
					this.ivaTotal = 0;
					this.totalFinal = this.netItemsConIva - totalDescuento + totalRecargo;
				} else {
					this.ivaTotal = this.sumaResumenDocumento[1] > 0 ? 0 : Math.round(netoAjustado * environment.taxPercentage);
					this.totalFinal = netoAjustado + this.ivaTotal - this.totalRetencionesCompra;
				}

				this.ref.detectChanges();

				// VALIDACIÓN DE TIPOS DE DTE CONSISTENTE
				const tipoCounts = cleanData.reduce<Record<string, number>>((acc, row: any) => {
					const tipo = this.esCompra() ? "46" : row["TipoDte"];
					acc[tipo] = (acc[tipo] || 0) + 1;
					return acc;
				}, {});
				const distintosTipos = Object.keys(tipoCounts);
				if (distintosTipos.length > 1) {
					const detalle = distintosTipos.map((t) => `• Tipo <b>${t}</b>: ${tipoCounts[t]} filas`).join("<br>");
					Swal.fire({
						icon: "error",
						title: "Tipo de documento inconsistente",
						html: `
              El archivo CSV contiene más de un tipo de DTE.<br><br>
              <strong>Detalle detectado:</strong><br>
              ${detalle}<br><br>
              Por favor, sube un archivo con un único tipo de documento.
            `,
					});
					this.loading = false;
					this.ref.detectChanges();
					return;
				}

				// VALIDACIÓN POR ÍTEM:
				// TotalProducto = (CantidadProducto x PrecioProducto) + RecargoProducto - DescuentoProducto
				this.inconsistencies = this.validateItemCalculations(cleanData);
				this.inconsistencyCount = this.inconsistencies.length;
				if (this.inconsistencyCount > 0) {
					const detalle = this.inconsistencies
						.map(
							(inc) =>
								`Fila ${inc.row}: (Cantidad ${inc.cantidad} x Precio ${inc.precio}) + Recargo ${inc.recargo} - Descuento ${inc.descuento} = ${inc.expected} != TotalProducto ${inc.total} (Delta ${inc.delta})`
						)
						.join("<br>");
					Swal.fire({
						icon: "error",
						title: "Se encontraron inconsistencias en el cálculo por ítem.",
						html: `Se detectaron <b>${this.inconsistencyCount}</b> inconsistencias:<br>${detalle}`,
					});
					this.loading = false;
					this.ref.detectChanges();
					return;
				}

				// OBTENCIÓN DE FOLIOS DESDE EL SII
				this.codigoSii = parseInt(tipoDteCsv, 10);
				this.foliosService.getDataByType(this.filter.emisorId, this.filter.sucursalId, this.codigoSii).subscribe(
					(res) => {
						const foliosData = res.data;
						const groupedFolios = this.groupArrayOfObjects(foliosData, "tipoDteId");
						for (const [tipoDteId, group] of Object.entries(groupedFolios)) {
							let sumOfDteType = 0;
							(group as any[]).forEach((currentObj) => {
								if (currentObj["activo"]) {
									sumOfDteType += currentObj["foliosDisponibles"];
								}
							});
							this.listFolioResumen.push({
								tipoDteId,
								suma: sumOfDteType,
								nombre: this.getDteTypeName(tipoDteId),
								codigoSii: (group as any[])[0]["codigoSii"],
							});
							this.ref.detectChanges();
							this.utilities.sortAlphabeth(this.listFolioResumen, "nombre");
						}
					},
					(error) => {
						Swal.fire({
							icon: "error",
							title: "Error en validación",
							text: "No fue posible realizar la validación de folios. " + this.utilities.setErrorMessageFromArray(error.error),
						});
					}
				);

				// VALIDACIÓN EXTERNA DE CABECERAS
				const stringType = this.getHeaderValidationType();
				this.facturadorService
					.validateHeaders(stringType, this.files[0])
					.subscribe(
						(res) => {
							this.externalValidFile = res.data as boolean;
							this.validationMessage = res.message;
							this.ref.detectChanges();
							if (!this.validFile) {
								Swal.fire({
									icon: "error",
									title: "Error de validación interna",
									text: "El archivo CSV contiene errores. Columnas inválidas: " + this.invalidColumns.join(", "),
								});
							} else if (!this.externalValidFile) {
								Swal.fire({
									icon: "error",
									title: "Error en validación externa",
									text: this.validationMessage,
								});
							} else {
								this.onConfirmation(this.summaryModal);
							}
						},
						(error) => {
							Swal.fire({
								icon: "error",
								title: "Error en validación externa",
								text: "No fue posible realizar la validación del archivo. " + this.utilities.setErrorMessageFromArray(error.error),
							});
						}
					)
					.add(() => {
						this.loading = false;
						this.ref.detectChanges();
					});
			},
		});
	}
	groupArrayOfObjects(list, key) {
		return list.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}
	getDteTypeName(dteTypeId): string {
		return this.tipoDteSource.find((type) => type.tipoDteId == dteTypeId).nombre;
	}
	createForm() {
		this.dteFileForm = this.formBuilder.group({
			file: [null, Validators.required],
			tipoCliente: [this.tipoClienteSource[0], Validators.required],
		});
	}

	private validateOptionalAprColumns(headers: string[]): { valid: boolean; missing: string[] } {
		const presentAprKeys = this.consumoAprOptionalKeys.filter((key) => headers.includes(key));

		// Si no viene ninguna columna APR, está OK
		if (presentAprKeys.length === 0) {
			return { valid: true, missing: [] };
		}

		const missingAprKeys = this.consumoAprOptionalKeys.filter((key) => !headers.includes(key));

		return {
			valid: missingAprKeys.length === 0,
			missing: missingAprKeys,
		};
	}

	onSelect(event) {
		if (event.rejectedFiles[0] || this.getName(event) != "csv") {
			let reason = "";
			if (event.rejectedFiles[0]) {
				reason = event.rejectedFiles[0].reason === "size" ? "Tamaño" : "Tipo de archivo";
			} else {
				reason = "Tipo de archivo";
			}
			this.setSwalAndFire(
				this.currentSwal,
				"error",
				"Error de Archivo",
				"El archivo ingresado no es de formato CSV, favor agregar un archivo con el formato correcto. Razón: " + reason
			);
		}

		this.files.push(...event.addedFiles);
		if (this.files.length > 1) {
			this.files.shift();
		}
		this.dteFileForm.patchValue({ file: this.files[0] });
	}
	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
	}

	getName(event): string {
		if (event.addedFiles) {
			return event.addedFiles[0].name.split(".").pop();
		} else if (event.rejectedFiles) {
			return event.rejectedFiles[0].name.split(".").pop();
		} else {
			return "";
		}
	}

	onConfirmation(summaryModal) {
		if (!this.canUploadSelectedType()) {
			Swal.fire({ icon: "warning", title: "Sin permiso de emisión", text: "Tu perfil no permite emitir el tipo de documento seleccionado." });
			return;
		}
		let obj = this.dteFileForm.controls.tipoCliente.value;
		this.tipoClienteId = obj.id;
		this.innerSummaryRef = this.modalService.open(summaryModal, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	confirmSwalOpener() {
		if (!this.canUploadSelectedType()) {
			Swal.fire({ icon: "warning", title: "Sin permiso de emisión", text: "Tu perfil no permite emitir el tipo de documento seleccionado." });
			return;
		}
		const foliosDisp = this.getFoliosByCodigoSii();
		if (foliosDisp < this.numberOfDocumentosToSend) {
			Swal.fire({
				icon: "error",
				title: "Folios insuficientes",
				text: `No hay suficientes folios disponibles para emitir los documentos requeridos. 
			  Actualmente, solo dispones de ${foliosDisp} folios.`,
			});

			return;
		}
		if (this.consultaMasivaRutsLenta) {
			const mensaje = `Se detectaron ${this.cantidadRutsPorConsultar} receptores con datos incompletos que podrían requerir consulta al SII. El proceso puede tardar más de lo normal. ¿Desea continuar?`;
			this.setSwalAndFire(this.confirmSwal, "info", "Ejecutar Facturación", mensaje);
			return;
		}
		this.setSwalAndFire(this.confirmSwal, "info", "Ejecutar Facturación", "¿Está seguro de facturar los documentos indicados en el archivo?");
	}
	onCancelUpload() {
		this.modalService.dismissAll();
		this.dteFileForm.reset();
	}

	canUploadSelectedType(checkFile: boolean = true): boolean {
		const tipoArchivo = this.dteFileForm?.controls.tipoCliente.value?.id;
		return this.permissions.getPermission("40-10-14").asignado &&
			(!this.esExportacion(tipoArchivo) || this.permissions.getPermission("40-19-10").asignado) &&
			(!checkFile || !this.fileData?.some(row => Number(row["TipoDte"]) === 43) || this.permissions.getPermission("40-21-10").asignado);
	}

	onUpload() {
		if (!this.canUploadSelectedType()) {
			Swal.fire({ icon: "warning", title: "Sin permiso de emisión", text: "Tu perfil no permite emitir el tipo de documento seleccionado." });
			return;
		}
		//close all after result, summaryModal and addModal
		this.modalService.dismissAll();
		this.addModal.close();
		let emisionMasivaString = {}; //object with expected data to create new element in backend, tipoClienteId & empresaId
		emisionMasivaString["tipoClienteId"] = this.dteFileForm.controls.tipoCliente.value;
		//emisionMasivaString["empresaId"] = this.dteFileForm.controls.filial.value;
		emisionMasivaString["CantidadSolicitada"] = this.fileData.length;
		//create SolicitudFacturacionMasiva
		let solicitud: SolicitudFacturacionMasiva = new SolicitudFacturacionMasiva();
		solicitud.emisorId = this.tokenStorage.getCompany();
		solicitud.sucursalId = this.tokenStorage.getSubsidiary();
		solicitud.cantidadSolicitada = this.fileData.length;
		solicitud.tipoArchivo = this.dteFileForm.controls.tipoCliente.value.id;
		solicitud.usuarioId = this.currentUser.id;
		this.iniciarIndicadorProcesamiento(solicitud.cantidadSolicitada);
		this.loading = true;
		//check form request method national or export
		let facturadorRequest: Observable<Response<ImportacionMasiva>>;
		if (solicitud.tipoArchivo == TipoArchivoImportacion.Exportacion) {
			facturadorRequest = this.facturadorService.addExportRequest(solicitud, this.files[0]);
		} else if (solicitud.tipoArchivo == TipoArchivoImportacion.Compras) {
			facturadorRequest = this.facturadorService.addPurchaseRequest(solicitud, this.files[0]);
		} else {
			facturadorRequest = this.facturadorService.add(solicitud, this.files[0]);
		}
		facturadorRequest
			.subscribe(
				(result) => {
					const tiempoTotalProcesamiento = this.actualizarTiempoProcesamiento();
					this.loading = false;
					this.ref.markForCheck();
					this.setPage({ offset: 0 });
					let message = result.message;
					this.setSwalAndFire(
						this.currentSwal,
						"success",
						"Facturación Exitosa",
						`Se han facturado los documentos solicitados\n\n${message}\n\nTiempo total del proceso: ${tiempoTotalProcesamiento}`
					);
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					let errorStrings = error.error ? (error.error.errors as string[]) : ["Error desconocido."];
					let completeErrorString = "";
					errorStrings.forEach((errorStr) => {
						// errorStr.replace("\\n", "<br>");
						// errorStr.replace("\\r\n", "<br>");
						completeErrorString += "<p>" + errorStr + "</p>";
					});
					Swal.fire({
						icon: "error",
						title: "Error de Facturación",
						showCloseButton: true,
						html: "<div style='text-align:left;'>No fue posible completar el proceso de facturación. <br>Detalle:<br>" + completeErrorString + "</div>",
					});
				}
			)
			.add(() => {
				this.detenerIndicadorProcesamiento();
				this.resetFormFacturacion();
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	private iniciarIndicadorProcesamiento(cantidadDocumentos: number) {
		this.detenerIndicadorProcesamiento();
		this.procesandoFacturacion = true;
		this.cantidadDocumentosProcesando = cantidadDocumentos;
		this.inicioProcesamiento = Date.now();
		this.tiempoProcesamiento = "00:00";
		this.procesoTardaMasEsperado = false;
		this.intervaloProcesamiento = setInterval(() => {
			this.actualizarTiempoProcesamiento();
			this.ref.detectChanges();
		}, 1000);
	}

	private actualizarTiempoProcesamiento(): string {
		const segundosTranscurridos = Math.max(0, Math.floor((Date.now() - this.inicioProcesamiento) / 1000));
		const minutos = Math.floor(segundosTranscurridos / 60);
		const segundos = segundosTranscurridos % 60;

		this.procesoTardaMasEsperado = segundosTranscurridos >= this.umbralSegundosProcesoLento;
		this.tiempoProcesamiento = `${minutos.toString().padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`;

		return this.tiempoProcesamiento;
	}

	private detenerIndicadorProcesamiento() {
		if (this.intervaloProcesamiento) {
			clearInterval(this.intervaloProcesamiento);
			this.intervaloProcesamiento = null;
		}
		this.procesandoFacturacion = false;
	}

	private contarRutsReceptorPorConsultar(filas: any[]): number {
		const rutsPorConsultar = new Set<string>();
		(filas || []).forEach((fila) => {
			const tipoDte = Number(fila["TipoDte"]);
			const rut = String(fila["RutRecep"] || "").trim().toUpperCase();
			const rutNormalizado = rut.replace(/\./g, "").replace(/\s/g, "");
			const razonSocial = String(fila["RazonSocialRecep"] || "").trim();
			const giro = String(fila["GiroRecep"] || "").trim();

			if (tipoDte === 39 || tipoDte === 41 || !rutNormalizado || rutNormalizado === "66666666-6" || rutNormalizado === "55555555-5") {
				return;
			}

			if (!razonSocial || !giro) {
				rutsPorConsultar.add(rutNormalizado);
			}
		});

		return rutsPorConsultar.size;
	}

	ngOnDestroy() {
		this.detenerIndicadorProcesamiento();
	}

	onShowResults() {}

	setSwalAndFire(swalReference: SwalComponent, iconString: SweetAlertIcon, titleString: string, textString: string) {
		swalReference.icon = iconString;
		swalReference.title = titleString;
		swalReference.text = textString;
		swalReference.fire();
	}

	CsvValidation(fileResult, requiredKeys: string[]): boolean {
		if (!fileResult || !fileResult.length) return false;
		const headers = Object.keys(fileResult[0]);
		return requiredKeys.every((key) => headers.includes(key));
	}
	resetFormFacturacion() {
		this.validFile = false;
		this.dteFileForm.reset();
		this.files = [];
		this.fileData = [];
		this.cantidadRutsPorConsultar = 0;
		this.invalidColumns = [];
		this.totalRetencionesCompra = 0;
	}

	setEmisorToElement(row: ImportacionMasiva) {
		let empresaAsociada = this.empresasSource.find((Emisor) => Emisor.emisorId == row.idEmisor);
		row.emisor = empresaAsociada;
	}

	setTipoArchivoToElement(row: ImportacionMasiva) {
		if (row.origenImportacionId == this.compraOrigenImportacionId) {
			row.nombreOrigenImportacion = "Compras";
			return;
		}
		row.nombreOrigenImportacion = this.tipoClienteSource.find((tipoArchivo) => tipoArchivo.id == row.origenImportacionId)?.nombre;
	}

	esExportacion(tipoArchivoId: number | string = this.tipoClienteId): boolean {
		return +tipoArchivoId === TipoArchivoImportacion.Exportacion;
	}

	esCompra(tipoArchivoId: number | string = this.tipoClienteId): boolean {
		return +tipoArchivoId === TipoArchivoImportacion.Compras;
	}

	parseImportedNumber(value: any): number {
		return this.esExportacion() ? this.utilities.realParseFloat(value) : parseFloat(value);
	}

	getHeaderValidationType(): string {
		if (this.esExportacion(this.dteFileForm.controls.tipoCliente.value.id)) {
			return "exporta";
		}
		if (this.esCompra(this.dteFileForm.controls.tipoCliente.value.id)) {
			return "compra";
		}
		return "nacional";
	}

	sortByProperty(rowsOfDocumentos: any[], propertyKey: string): any[] {
		var groupBy = function (rowsOfDocumentos, propertyKey) {
			return rowsOfDocumentos.reduce(function (rv, x) {
				(rv[x[propertyKey]] = rv[x[propertyKey]] || []).push(x);
				return rv;
			}, {});
		};
		return groupBy(rowsOfDocumentos, propertyKey);
	}

	sumArrayProperty(arrayToSum: Array<any>, propertyToSum: string) {
		let sum: number = 0;
		let auxValue;
		arrayToSum.forEach((detailRow) => {
			auxValue = detailRow[propertyToSum];
			if (!Number.isNaN(auxValue) && auxValue != undefined && auxValue != "") {
				sum += this.parseImportedNumber(auxValue);
			}
		});
		return sum;
	}

	getSumAfectosExentos(arrayToSum: Array<any>, propertyToSum: string, propertyToCheck: string): [number, number] {
		let sumaNetoAfecto = 0;
		let sumaExento = 0;
		let auxValue;
		let auxExento; //toma valor string de grilla, se pasa a numerico en la sgte variable
		let isExento; //0:Afecto | 1:Exento
		try {
			arrayToSum.forEach((detailRow) => {
				auxValue = detailRow[propertyToSum];
				auxExento = detailRow[propertyToCheck];
				isExento = +auxExento;
				if (!Number.isNaN(auxValue) && auxValue != undefined && auxValue != "" && isExento != undefined) {
					if (isExento) {
						sumaExento += this.parseImportedNumber(auxValue);
					} else {
						sumaNetoAfecto += this.parseImportedNumber(auxValue);
					}
				}
			});
		} catch (error) {
			console.log(error);
			Swal.fire({
				icon: "error",
				title: "Error en lectura",
				text: "Se ha producido un error al leer los datos del documento." + error,
			});
		}

		return [sumaNetoAfecto, sumaExento];
	}

	validateItemCalculations(arrayToCheck: Array<any>): any[] {
		const inconsistencies: any[] = [];
		try {
			arrayToCheck.forEach((row: any, index: number) => {
				const cantidadRaw = row["CantidadProducto"];
				const precioRaw = row["PrecioProducto"];
				const totalRaw = row["TotalProducto"];
				const descuentoRaw = row["DescuentoProducto"];
				const recargoRaw = row["RecargoProducto"];
				if (cantidadRaw == undefined || precioRaw == undefined || totalRaw == undefined) return;
				const parseLocal = (v: any) => {
					const s = String(v).trim();
					if (s === "") return Number.NaN;
					if (s.includes(",")) return parseFloat(s.replace(/\./g, "").replace(",", "."));
					return parseFloat(s);
				};

				const parseValue = (v: any, defaultToZero: boolean = false): number => {
					if (v === undefined || v === null || String(v).trim() === "") {
						return defaultToZero ? 0 : Number.NaN;
					}

					const parsed = this.tipoClienteId == 0 ? parseLocal(v) : this.utilities.realParseFloat(v);
					return Number.isNaN(parsed) && defaultToZero ? 0 : parsed;
				};

				const cantidad = parseValue(cantidadRaw);
				const precio = parseValue(precioRaw);
				const total = parseValue(totalRaw);
				const descuento = parseValue(descuentoRaw, true);
				const recargo = parseValue(recargoRaw, true);

				if (Number.isNaN(cantidad) || Number.isNaN(precio) || Number.isNaN(total)) return;
				const expected = Math.round(cantidad * precio + recargo - descuento);
				const delta = total - expected;
				const EPS = 0;
				if (Math.abs(delta) > EPS) {
					inconsistencies.push({ row: index + 1, cantidad, precio, descuento, recargo, total, expected, delta });
				}
			});
		} catch (error) {
			console.error("Error en validación por ítem:", error);
		}
		return inconsistencies;
	}

	private getTotalRetencionesCompra(rows: Array<any>): number {
		return rows.reduce((sum: number, row: any) => sum + this.getRetencionCompraByRow(row), 0);
	}

	private getRetencionCompraByRow(row: any): number {
		const indicadorExentoRaw = row["IndicadorExento"];
		const isExento = this.parseImportedNumber(indicadorExentoRaw || 0) !== 0;
		if (isExento) {
			return 0;
		}

		const base = this.parseImportedNumber(row["TotalProducto"] || 0);
		if (!Number.isFinite(base) || base <= 0) {
			return 0;
		}

		const tasa1 = this.parseImportedNumber(row["TasaRetencion1"] || 0);
		const tasa2 = this.parseImportedNumber(row["TasaRetencion2"] || 0);

		const ret1 = tasa1 > 0 ? Math.round(base * (tasa1 / 100)) : 0;
		const ret2 = tasa2 > 0 ? Math.round(base * (tasa2 / 100)) : 0;

		return ret1 + ret2;
	}

	private calculateGlobalDiscountAndRecargo(arrayToCheck: Array<any>): {
		totalDescuentoPesos: number;
		totalDescuentoPorcentaje: number;
		totalRecargopesos: number;
		totalRecargoporcentaje: number;
	} {
		const result = {
			totalDescuentoPesos: 0,
			totalDescuentoPorcentaje: 0,
			totalRecargopesos: 0,
			totalRecargoporcentaje: 0,
		};

		const basesPorDocumento = this.getBaseByDocument(arrayToCheck);
		const dedup = new Set<string>();

		arrayToCheck.forEach((row: any) => {
			const tipoMovimiento = this.parseImportedNumber(row.TpoMov || 0);
			const tipoValor = this.parseImportedNumber(row.TpoValor || 0);
			const valorDr = this.parseImportedNumber(row.ValorDR || 0);
			const id = (row.Id ?? "").toString().trim();

			if (!id || !(tipoMovimiento === 1 || tipoMovimiento === 2) || !(tipoValor === 1 || tipoValor === 2) || !Number.isFinite(valorDr) || valorDr === 0) {
				return;
			}

			const dedupKey = `${id}|${tipoMovimiento}|${tipoValor}|${valorDr}|${row.GlosaDR ?? ""}|${row.IndExeDR ?? ""}|${row.ValorOtrMnda ?? ""}`;
			if (dedup.has(dedupKey)) {
				return;
			}
			dedup.add(dedupKey);

			const baseDocumento = basesPorDocumento.get(id) ?? 0;
			if (baseDocumento <= 0) {
				return;
			}

			if (tipoMovimiento === 1 && tipoValor === 2) {
				result.totalDescuentoPesos += valorDr;
			}
			if (tipoMovimiento === 1 && tipoValor === 1) {
				result.totalDescuentoPorcentaje += baseDocumento * (valorDr / 100);
			}
			if (tipoMovimiento === 2 && tipoValor === 2) {
				result.totalRecargopesos += valorDr;
			}
			if (tipoMovimiento === 2 && tipoValor === 1) {
				result.totalRecargoporcentaje += baseDocumento * (valorDr / 100);
			}
		});

		return result;
	}

	private getBaseByDocument(rows: Array<any>): Map<string, number> {
		const map = new Map<string, { afecto: number; exento: number }>();

		rows.forEach((row: any) => {
			const id = (row.Id ?? "").toString().trim();
			if (!id) {
				return;
			}

			const totalProducto = this.parseImportedNumber(row.TotalProducto || 0);
			if (!Number.isFinite(totalProducto) || totalProducto === 0) {
				return;
			}

			const isExento = this.parseImportedNumber(row.IndicadorExento || 0) !== 0;
			const current = map.get(id) ?? { afecto: 0, exento: 0 };
			if (isExento) {
				current.exento += totalProducto;
			} else {
				current.afecto += totalProducto;
			}
			map.set(id, current);
		});

		const baseMap = new Map<string, number>();
		map.forEach((value, key) => {
			baseMap.set(key, value.exento > 0 ? value.exento : value.afecto);
		});

		return baseMap;
	}

	//Formato debe contener:
	//numero de columnas, nombre de las columnas , formato de las columnas
	ordenarPorFecha(lista: ImportacionMasiva[]) {
		lista.sort((a: ImportacionMasiva, b: ImportacionMasiva) => {
			return new Date(b.fechaCarga).getTime() - new Date(a.fechaCarga).getTime();
		});
	}

	chosenYearHandler(normalizedYear: Moment) {
		let ctrlValue = moment(this.dateFrom);
		ctrlValue.year(moment(normalizedYear).year());
		this.dateFrom = moment(ctrlValue);
		this.ref.detectChanges();
	}

	chosenMonthHandler(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>) {
		let ctrlValue = moment(this.dateFrom);
		ctrlValue.month(moment(normalizedMonth).month());
		this.dateFrom = moment(ctrlValue);
		this.ref.detectChanges();
		datepicker.close();
	}
	chosenYearHandlerDateTo(normalizedYear: Moment) {
		let ctrlValue = moment(this.dateTo);
		ctrlValue.year(moment(normalizedYear).year());
		this.dateTo = moment(ctrlValue);
		this.ref.detectChanges();
	}

	chosenMonthHandlerDateTo(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>) {
		let ctrlValue = moment(this.dateTo);
		ctrlValue.month(moment(normalizedMonth).month());
		this.dateTo = moment(ctrlValue);
		this.ref.detectChanges();
		datepicker.close();
	}

	getMonthYear(date: Date) {
		return moment(date).month() + "," + moment(date).year();
	}

	detectChangeStartDate(event) {
		let fromDate = moment();
		if (event.target != null) {
			fromDate = moment((<HTMLInputElement>event.target).value, "DD/MM/YYYY");
			this.dateFrom.startDate = fromDate;
		}
	}
	detectChangeEndDate(event) {
		let toDate = moment();
		if (event.target != null) {
			toDate = moment((<HTMLInputElement>event.target).value, "DD/MM/YYYY");
			this.dateTo.endDate = toDate;
		}
	}

	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}
	setPage(pageInfo, $event?) {
		if ($event) {
			this.filter.fechaDesde = $event.fechaInicio;
			this.filter.fechaHasta = $event.fechaFin;
			this.filter.origen = $event.origenImportacion;
			this.filter.sucursalId = $event.sucursalId ? $event.sucursalId : this.currentSucursal;
			this.filter.emisorId = $event.emisorId ? $event.emisorId : this.emisorId;
		}
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		//this.page.pageNumber +=1;
		this.facturadorService
			.getDataByPage(this.filter, localPage)
			.subscribe(
				(result) => {
					let elements = result.data as ImportacionMasiva[];
					elements.forEach((row) => {
						this.setEmisorToElement(row);
						//this.setTipoArchivoToElement(row);
						row.fechaCarga = moment(row.fechaCarga);
					});
					this.ordenarPorFecha(elements);
					if (elements) {
						this.rowsMantenedor = [...elements];
					}
					this.ref.detectChanges();

					this.setPageFromResponse(this.page, result);
					this.ref.detectChanges();
				},
				(error) => {
					this.setSwalAndFire(this.currentSwal, "error", "Error en solicitud", "No es posible obtener los datos.\nDetalle: " + this.utilities.setErrorMessageFromArray(error.error));
				}
			)
			.add(() => {
				this.loading = false;
				this.componentStarted = true;
				this.ref.detectChanges();
			});
	}

	setPageFromResponse(currentPage: Page, data: PagedResponse<ImportacionMasiva>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < -1 ? 0 : data.pageNumber - 1;

		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	// getSample2(tipo:number){
	//   this.loading= true;
	//   this.facturadorService.downloadSample(tipo).subscribe(
	//     (res)=>{
	//       this.loading = false;
	//       const arr = res.split('\r\n');
	//       this.ref.detectChanges();
	//       const header = arr[0].split(';');
	//       arr.shift;
	//       let splittedCsvRows = [];
	//       arr.forEach(fullRow => {
	//         let splitedRow = fullRow.split(';');
	//         splittedCsvRows.push(splitedRow);
	//       });
	//       let csvContent = "data:text/csv;charset=utf-8," + splittedCsvRows.map(e => e.join(";")).join("\r\n");
	//       var encodedUri = encodeURI(csvContent);
	//       var link = document.createElement("a");
	//       link.setAttribute("href", encodedUri);
	//       let name = tipo==1?'ejemplo_carga_exportación':'ejemplo_carga_masiva'
	//       link.setAttribute("download", name);
	//       document.body.appendChild(link);
	//       link.click();
	//     },
	//     (error)=>{
	//       this.loading = false;
	//       this.ref.detectChanges();
	//       Swal.fire({
	//         icon:'error',
	//         title:'Error en Ejemplo',
	//         text:'No fue posible obtener el archivo de ejemplo, intente nuevamente.'
	//       })
	//     }
	//   )
	// }

	getSample(tipo: number) {
		this.loading = true;
		this.facturadorService.downloadSample(tipo).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				let filename = "ejemplo_carga_masiva_nacional.csv";
				if (tipo == TipoArchivoImportacion.Exportacion) {
					filename = "ejemplo_carga_masiva_exportacion.csv";
				} else if (tipo == TipoArchivoImportacion.Compras) {
					filename = "ejemplo_carga_masiva_compras.csv";
				}
				let dataType = res.type;
				let binaryData = [];
				binaryData.push(res);
				let blob = new Blob(binaryData, { type: dataType });
				let downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", filename);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Ejemplo",
					text: "No fue posible obtener el archivo de ejemplo, intente nuevamente.",
				});
			}
		);
	}

	downloadInstructions() {
		this.loading = true;
		this.facturadorService.getPdfInstructions().subscribe(
			(result) => {
				this.PdfDownload(result.data, "Instrucciones Facturación Masiva");
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Descargar Pdf",
					text: "No fue posible descargar el pdf de instrucciones de facturación masiva, intentar nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	CsvDataToObjects(data: any[]): Object[] {
		let results = [];
		var headersLine: string[] = Object.values(data[0]);
		var dataLines: string[] = [];
		var headers = headersLine[0].split(";");
		data.shift();
		data.forEach((element) => {
			let dataline: string[] = Object.values(element);
			let dataArray = dataline[0].split(";");
			let obj = {};
			for (let index = 0; index < dataArray.length; index++) {
				obj[headers[index]] = dataArray[index];
			}
			results.push(obj);
		});
		return results;
	}

	concatValuesToObjProperty(obj, propertyToSet, propertyToGet) {
		let arrayValues = [];
		if (obj[propertyToGet]) {
			let arrayPropertiesToConcat = obj[propertyToGet].forEach((element) => (obj[propertyToSet] += element));
			obj[propertyToSet] += arrayPropertiesToConcat;
		}
	}

	detectChangeDate(event) {
		let fromDate = moment();
		if (event.startDate != null) {
			this.dateMatrixRequest = event;
		}
		if (event.target != null && event.target.value != null) {
			this.validDate = moment(event.target.value, "DD/MM/YYYY", true).isValid();
			if (this.validDate) {
				fromDate = new Object();
				fromDate.startDate = moment(event.target.value, "DD-MM-YYYY");
				this.dateMatrixRequest = fromDate;
			}
		}
	}

	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}

	PdfDownload(responseB64, name) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "text/pdf");
		FileSaver.saveAs(pdfBlob, name + ".pdf");
		this.loading = false;
		this.ref.detectChanges();
	}

	downloadGlossary() {
		this.loading = true;
		this.facturadorService.getPdfGlossary().subscribe(
			(result) => {
				this.PdfDownload(result.data, "Glosario");
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Descargar Pdf",
					text: "No fue posible descargar el pdf de glosario, favor recargar intentar nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	checkConflictInDelimiter(result: ParseResult) {
		let containsSeparator = Object.keys(result.data[0] as string).some((n) => n.includes(";"));
		return containsSeparator;
	}

	getEmisoresFullList() {
		this.emisorService.getData().subscribe(
			(result) => {
				let emisores = result.data;
				this.empresasSource = emisores;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en emisores",
					text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	getFoliosByCodigoSii(): number {
		// Si no hay datos o el array está vacío, regresamos 0 (o lo que tú prefieras).
		if (!this.listFolioResumen || this.listFolioResumen.length === 0) {
			return 0;
		}
		// Asumiendo que la variable guarda objetos con { codigoSii, suma, nombre... }
		const encontrado = this.listFolioResumen.find((item) => item.codigoSii === this.codigoSii);
		return encontrado ? encontrado.suma : 0;
	}
}
